export enum SortType {
  default = 1,
  decreasing = 0
}
